import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter, HostListener,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {AllocationRequest} from "../../../../../model/clearing/allocation/allocation-request";
import {ClearingAllocationService} from "../../../../../services/clearing/clearing-allocation.service";
import {CcBaseComponent} from "../../../../../crystal-elements/cc-base.component";
import {FormFieldConfig} from "../../../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../../../model/api/form-field-group-config";
import {Order} from "../../../../../model/clearing/order";
import TYPE = FormFieldConfig.TYPE;
import {FieldRecord} from "../../../../../model/api/field-record";

@Component({
  selector: 'app-clearing-select-table-columns-form',
  templateUrl: './select-table-columns-form.component.html',
  styleUrls: ['./select-table-columns-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectTableColumnsFormComponent extends CcBaseComponent {

  formLoading: boolean = false;

  formSubmitted: boolean = true;

  formConfig: FormFieldGroupConfig[] = [];

  dialogFormTitle: string = '';

  formRecord: {} | any;

  loadingProgressValue: number = 100;
  dialogFormVisible: boolean = false;

  @Output()
  onSavedForm = new EventEmitter<any>();

  availableColumns: FieldRecord<any>[] = [];

  constructor(cdref: ChangeDetectorRef,
              private allocationService: ClearingAllocationService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
    this.formRecord = {};
    this.dialogFormTitle = this.getTranslation('common.table.select_visible_columns');
  }

  protected refreshConfigs() {
    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'visibleColumns',
            label: ' ',
            style: record => '',
            column: 12,
            type: TYPE.PICKLIST,
            filter: true,
            dragdrop: false,
            headerTitle1:   this.getTranslation('common.table.select_visible_columns_header1'),
            headerTitle2:   this.getTranslation('common.table.select_visible_columns_header2'),
            options: record => this.availableColumns
          }]
      }];
  }

  public open(columns: FieldRecord<any>[], visibleColumns: string[]): void {
    this.formRecord = {
      visibleColumns: visibleColumns
        .map(colId => columns.find(column => column.id === colId))
        .filter(column => !!column)
    }
    this.availableColumns = columns.filter(column => !visibleColumns.includes(column.id));
    this.refreshConfigs();
    this.dialogFormVisible = true;
    this.markForCheck();
  }
  save() {
    this.onSavedForm.emit(this.formRecord.visibleColumns.map(column => column.id));
    this.closeDialogForm();
  }

  closeDialogForm(): void {
    this.dialogFormVisible = false;
    this.markForCheck();
  }

}
